import $ from 'jquery';

/**
 * Created by Beni on 2016. 05. 09..
 */

function AppAjaxEventLayerInit() {
    var selector = '#ajax_operations';
    $(document).ajaxError(function () {
        //console.log("ajax-error");
        $(selector).fadeOut(500);
    });
    $(document).ajaxComplete(function () {
        //console.log("ajax-complete");
        $(selector).fadeOut(500);
    });
    $(document).ajaxSend(function () {
        //console.log("ajax-start");
        $(selector).fadeIn(500);
    });
}

function AppAjaxEventLayerOff() {
    $(document).off('ajaxError');
    $(document).off('ajaxComplete');
    $(document).off('ajaxSend');
}

$(document).ready(function () {
    console.log("init livegame");
    var liveGame = LiveGame;
    var initObj = $("#live-game-init");
    liveGame.init(initObj.data("version"), initObj.data("url"), initObj.data("gameid"), initObj.data("status"));
    //console.log(liveGame);
});

var LiveGame = {
    //version: 0,
    url: null,
    gameId: null,
    status: null,
    periode: 60000,
    timer : null,
    headObj: null,
    timelineObj: null,
    historyObj: null,
    teamupObj: null,

    init: function (version, url, gameId, status) {
        //this.version = version;
        this.url = url;
        this.gameId = gameId;
        this.status = status;
        this.headObj = $("#game-head");
        this.timelineObj = $("#game-timeline");
        this.historyObj = $("#game-history");
        this.teamupObj = $("#game-teamup");
        this.start();
    },

    start : function(){
        var live = this;
        //status: live, ended, scheduled, pre
        if(this.status == "live" || this.status == "scheduled"){
            this.timer = setTimeout(function(){
                live.sendAjax(live.url, {"gameId" : live.gameId})
            }, this.periode);
        }
    },

    stop : function(){
        if(this.timer){
            clearInterval(this.timer);
            this.timer = null;
        }
    },

    sendAjax: function (url, data) {
        var live = this;
        AppAjaxEventLayerOff();
        $.ajax({
            type: "GET",
            url: url,
            data: data,
            crossDomain: true,
            headers: {'X-Requested-With':'XMLHttpRequest'},
            success: function (ret) {
                if(ret.status){
                    live.status = ret.status;
                }
                if(ret.head){
                    live.headObj.html(ret.head);
                }
                if(ret.timeline){
                    live.timelineObj.html(ret.timeline);
                }
                if(ret.history){
                    live.historyObj.html(ret.history);
                }
                if(ret.teamup){
                    live.teamupObj.html(ret.teamup);
                }
                live.start();
                AppAjaxEventLayerInit();
            },
            error : function(){
                live.start();
                AppAjaxEventLayerInit();
            }
        });
    }
};
